import React, { useContext } from "react";
import AuthContext from "../context/Authcontext";
import { Link } from "react-router-dom";

const Loginpage = () => {
  const { contextData } = useContext(AuthContext);

  return (
    <div className="login-container">



<div className="link-log-reg-container">
        
        <h1>Login</h1>
      </div>




      <form className="loginform" onSubmit={contextData.loginuser}>
        <input required type="text" placeholder="enter the email" name="email" />
        <input
          type="password"
          placeholder="enter the password"
          name="password"
        />
        <input required type="submit" value={"SEND"} />
      </form>


     <div className="link-log-reg-container">

      <Link className="register-goto-login-link" to={"/register"}><span className="aling">Don't have an account?</span> Register</Link>
      </div>



    </div>
  );
};

export default Loginpage;
